import React from 'react';

/**
 * Animated typing indicator shown while the bot is generating a response.
 */
const ScanLineLoader = () => (
  <div className="chatbot-typing-indicator">
    <span></span>
    <span></span>
    <span></span>
  </div>
);

export default ScanLineLoader;
